import { z } from "zod"

export const SpecialPriceSchema = z.object({
  customerId: z
    .string()
    .nullable()
    .refine((value): boolean => value !== null, { message: "Customer is required" }),

  shipFrom: z
    .string()
    .nullable()
    .refine((value): boolean => value !== null, { message: "Ship From is required" }),

  incoterms: z
    .string()
    .nullable()
    .refine((value): boolean => value !== null, { message: "Incoterms is required" }),
  incotermsLocation: z
    .string()
    .nullable()
    .refine((value): boolean => value !== null, { message: "Incoterms Location is required" }),
})

export type SpecialPriceSchemaFormValues = z.infer<typeof SpecialPriceSchema>
